module.exports = __webpack_public_path__ + "static/media/Slide1.c829422a.JPG";